import type { FaireProductEntity } from "../../entity_types/product";

export const p_pk3gmntjaf: FaireProductEntity = {
  token: "p_pk3gmntjaf",
  type: "product",
  name: "Bride Wedding Beaded Southern Statement Earrings",
  brandToken: "b_vjqfbthsp3",
  brandName: "Brookhaven Baubles",
  imageUrl: "https://cdn.faire.com/fastly/b34e96847dfb6c77523bbb7d5b5b9e74c743faf3000307d32c8d2aa71b39531b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2972b3ec5ed151dd943f60fc5f6e1397e7f13ee20db13b85b8d76270682baca3.jpeg",
    "https://cdn.faire.com/fastly/22ea2993d6417f8179e3a30e04a7951ea7cb7041fbf8f31754c29ab116897eba.jpeg",
    "https://cdn.faire.com/fastly/744b5178072c63b55f61cc1523f401742b9836bae01d5fc4c1553b6fb095d6ae.jpeg",
    "https://cdn.faire.com/fastly/701b15b55fc0e9de796fcec5794349f640b277633e758661d1bf5033a99f52ff.jpeg"
  ],
  priceDollars: 14,
  description: "Bride Wedding Beaded Earrings - Brookhaven Baubles - Southern Statement Jewelry - Statement Earrings\n\nBride Wedding Beaded Earrings - Southern Statement Jewelry - Beaded Statement Earrings - Fashion Earrings for Her\n\nThese lightweight earrings are made from acrylic seed beads and they are so lightweight you will practically forget you are wearing them.\n\nOur earrings are the perfect statement for any occasion or outfit! Perfect for every occasion, from casual days to special events like weddings and birthdays. Get a pair for yourself, your bestie, or as a gift!\n\nAll posts are lead and nickel-free and very lightweight for easy everyday wear.\n\nAll images are copyrighted by Brookhaven Baubles. All rights reserved.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T16:32:05.663Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
